import React from "react";

/**
 * StatCard component for displaying statistics in a stylized card
 * @param {string} title - The title of the stat card
 * @param {number|string} value - The value to display
 * @param {React.ReactNode} icon - The icon to display
 * @param {string} color - The color for the icon
 */
const StatCard = ({ title, value, icon: Icon, color }) => (
  <div
    style={{
      padding: "16px",
      borderRadius: "8px",
      backgroundColor: "white",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>
        {title}
      </span>
      <div style={{ color }}>{Icon}</div>
    </div>
    <div style={{ fontSize: "24px", fontWeight: "bold", color: "#1e293b" }}>
      {title.includes("Revenue") || title.includes("Profit")
        ? `EGP ${value}`
        : value}
    </div>
  </div>
);

export default StatCard;
